export default "__VITE_ASSET__BC22GpzT__"